<script setup>
import { ref } from 'vue'

const pourcent = ref(0)

const setProgress = (progress) => {
  if (typeof progress !== 'number' || progress < 0) pourcent.value = 0
  else if (progress > 1) pourcent.value = 100
  else pourcent.value = Math.round(progress * 100)
}

defineExpose({
  setProgress
})

</script>

<template>
  <div class="progress-bar">
    <div class="inner-bar" :style="{ width: `${pourcent}%`}">
      <span>{{ `${pourcent}%` }}</span>
    </div>
  </div>
</template>